<template>
    <form v-if="status.detail" @submit.prevent="submitForm">
        <b-form-group :label="$t('label.name')" label-cols="3" label-align="left">
            <b-form-input v-model.trim="form.name" :state="fieldState" />
            <b-form-invalid-feedback>{{ $t('message.requiredX', [$t('label.name')]) }}</b-form-invalid-feedback>
        </b-form-group>
        <b-form-group :label="$t('label.image')" label-cols="3" label-align="left">
            <b-form-file v-model="form.file" accept="image/*" :state="fileState"
                :placeholder="$t('label.chooseIconImage')" />
            <b-form-text v-if="iconUUID && form.url">{{ $t('label.keepCurrentIcon') }}</b-form-text>
            <div v-if="submitted && !form.file && !form.url" class="invalid-feedback d-block text-right">
                {{ $t('label.iconRequired') }}
            </div>
        </b-form-group>
        <b-form-group :label="$t('label.status')" label-cols="3" label-align="left">
            <b-form-checkbox v-model="form.isActive" switch>
                {{ form.isActive ? $t('label.active') : $t('label.inactive') }}
            </b-form-checkbox>
        </b-form-group>
        <hr class="my-3 mx-n3">
        <div class="d-flex justify-content-end">
            <b-button type="button" variant="danger" class="mr-2" @click="$emit('done')">{{ $t('label.cancel')
                }}</b-button>
            <b-button type="submit" variant="info" :disabled="!status.save">
                <span v-if="status.save">{{ $t(iconUUID ? 'label.updateX' : 'label.createX',
                    [$t('module.notificationIcon')]) }}</span>
                <b-spinner v-else small />
            </b-button>
        </div>
    </form>
    <div v-else class="d-flex justify-content-center p-5"><b-spinner variant="info" /></div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { mapState } from 'vuex';
import { notificationIconMethods } from '@/state/api';
import { NOTIFICATION_ICON_MODULE } from '@/state/api/notificationIcon.state';

export default {
    name: 'NotificationIconForm',
    props: {
        iconUUID: { type: String, default: '' },
        searchCriteria: { type: Object, required: true }
    },
    data() {
        return {
            submitted: false,
            form: {
                uuid: '',
                name: '',
                file: null, url: '',
                isActive: true
            }
        };
    },
    validations: {
        form: {
            name: { required }
        }
    },
    computed: {
        ...mapState(NOTIFICATION_ICON_MODULE, ['status']),
        details() {
            return this.$store.state.api.notificationIcon.details || {};
        },
        fieldState() {
            return this.submitted ? !this.$v.form.name.$invalid : null;
        },
        fileState() {
            return this.submitted ? Boolean(this.form.file || this.form.url) : null;
        },
    },
    created() {
        this.loadIcon();
    },
    methods: {
        ...notificationIconMethods,
        async loadIcon() {
            if (!this.iconUUID) return;
            const result = await this.getNotificationIcon({ uuid: this.iconUUID });
            if (result) {
                this.form = {
                    ...this.form,
                    ...this.details,
                    file: null
                };
            }
        },
        async submitForm() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid || (!this.form.file && !this.form.url)) return;
            const action = this.iconUUID ? this.updateNotificationIcon : this.createNotificationIcon;
            const result = await action({ data: this.form, filter: this.searchCriteria });
            if (result?.success) {
                this.$emit('done');
            }
        },
    },
};
</script>
